export default __webpack_public_path__ + "static/media/logonav.08da23ef.png";